<template>
  <!-- Approvals: start -->
  <div class="mt-5 flex items-center justify-center gap-2">
    <div class="flex flex-col items-center w-14">
      <p class="text-md font-normal">{{ fullyAgreePercentage }}%</p>
      <div class="bg bg-markencode-green h-1.5 w-full"></div>
      <p class="text-md font-normal">{{ fullyAgree }}</p>
    </div>

    <div class="flex flex-col items-center w-14">
      <p class="text-md font-normal">{{ agreePercentage }}%</p>
      <div class="bg bg-markencode-light-green h-1.5 w-full"></div>
      <p class="text-md font-normal">{{ agree }}</p>
    </div>

    <div class="flex flex-col items-center w-14">
      <p class="text-md font-normal">{{ noButGoAlongPercentage }}%</p>
      <div class="bg bg-markencode-yellow h-1.5 w-full"></div>
      <p class="text-md font-normal">{{ noButGoAlong }}</p>
    </div>

    <div class="flex flex-col items-center w-14">
      <p class="text-md font-normal">{{ vetoPercentage }}%</p>
      <div class="bg bg-markencode-red h-1.5 w-full"></div>
      <p class="text-md font-normal">{{ veto }}</p>
    </div>


  </div>
  <!-- Approvals: end -->
</template>

<script>
import { sum } from 'lodash';

export default {
  name: 'ProfileApprovals',

  props: ['session', 'approvalStats'],

  data() {
    return {
      approvals: {
        fully_agree: this.approvalStats.fully_agree || 0,
        agree: this.approvalStats.agree || 0,
        no_but_go_along: this.approvalStats.no_but_go_along || 0,
        veto: this.approvalStats.veto || 0,
      },
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.profile-approval.submitted',
      (e) => {

        console.log('profile-approval.submitted');

        this.approvals = e.approvals || {
          fully_agree: 0,
          agree: 0,
          no_but_go_along: 0,
          veto: 0,
        };
      }
    );
  },

  computed: {
    total() {
      return sum(Object.values(this.approvals));
    },
    
    fullyAgree() {
      return this.approvals.fully_agree || 0;
    },
    agree() {
      return this.approvals.agree || 0;
    },
    noButGoAlong() {
      return this.approvals.no_but_go_along || 0;
    },
    veto() {
      return this.approvals.veto || 0;
    },


    fullyAgreePercentage() {
      if (this.total <= 0 || !this.approvals.fully_agree) {
        return 0;
      }

      return ((this.approvals.fully_agree / this.total) * 100).toFixed(0);
    },
    agreePercentage() {
      if (this.total <= 0 || !this.approvals.agree) {
        return 0;
      }

      return ((this.approvals.agree / this.total) * 100).toFixed(0);
    },
    noButGoAlongPercentage() {
      if (this.total <= 0 || !this.approvals.no_but_go_along) {
        return 0;
      }

      return ((this.approvals.no_but_go_along / this.total) * 100).toFixed(0);
    },
    vetoPercentage() {
      if (this.total <= 0 || !this.approvals.veto) {
        return 0;
      }

      return ((this.approvals.veto / this.total) * 100).toFixed(0);
    },
  },
};
</script>